import elementoVisivel from '../dom';

const FORM = '[data-tour="recursos-form-razoes"]';
const ASSUNTO = '[data-tour="recursos-form-razoes-assunto"]';
const MENSAGEM = '[data-tour="recursos-form-razoes-mensagem"]';
const UPLOAD = '[data-tour="recursos-form-razoes-upload"]';
const ENVIAR = '[data-tour="recursos-enviar-razoes"]';

export default {
  id: 'recursos-form-razoes',
  kind: 'tour',
  version: 1,
  label: 'Enviar recurso',
  contexts: ['auction.recursos'],
  scopes: ['form-razoes'],
  priority: 10,
  help: true,
  canQueue(ctx = {}) {
    return Boolean(ctx.logged && ctx.podeApresentarRazoes);
  },
  canStart(ctx = {}) {
    if (!ctx.logged || !ctx.formVisible) return false;
    if (ctx.podeApresentarRazoes === false) return false;
    return Boolean(elementoVisivel(FORM));
  },
  steps() {
    const steps = [
      {
        element: FORM,
        popover: {
          title: 'Enviar recurso',
          description:
            'Use este formulário para apresentar o recurso dentro do prazo de interposição.',
          side: 'top',
          align: 'start',
        },
      },
    ];

    if (elementoVisivel(ASSUNTO)) {
      steps.push({
        element: ASSUNTO,
        popover: {
          title: 'Assunto',
          description: 'Informe um assunto objetivo que identifique o objeto do seu recurso.',
          side: 'bottom',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(MENSAGEM)) {
      steps.push({
        element: MENSAGEM,
        popover: {
          title: 'Recurso',
          description: 'Descreva aqui o recurso. Este campo é obrigatório.',
          side: 'top',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(UPLOAD)) {
      steps.push({
        element: UPLOAD,
        popover: {
          title: 'Anexos',
          description: 'Se necessário, anexe documentos que fundamentem o recurso apresentado.',
          side: 'left',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(ENVIAR)) {
      steps.push({
        element: ENVIAR,
        popover: {
          title: 'Enviar Recurso',
          description:
            'Ao enviar, o recurso fica registrado. Enquanto estiver na janela de recursos, você poderá editar ou excluir.',
          side: 'top',
          align: 'start',
        },
      });
    }

    return steps;
  },
};
